import { Component, OnDestroy, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidenavComponent } from '../../components/sidenav/sidenav.component';
import { ApplicationHeaderComponent } from '../../components/fcc-601/header/application-header/application-header.component';
import { ApplicationNavigationStepsComponent } from '../../components/fcc-601/navigation-steps/application-navigation-steps.component';
import { ApplicationFooterComponent } from '../../components/fcc-601/footer/application-footer.component';
import { MasqueradeHeaderComponent } from '../../components/masquerade-header/masquerade-header.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { AsyncPipe } from '@angular/common';
import { LoadingService } from '../../../core/services/loading/loading.service';
import { Subject } from 'rxjs';
import { ApplicationStateService } from '../../../modules/application/shared/services/application-state/application-state.service';
import { ApplicationCoordinationNavigationBarComponent } from '../../../modules/application/coordination/shared/components/application-coordination-navigation-bar/application-coordination-navigation-bar.component';
import { ApplicationFormControlManagerService } from '../../../modules/application/shared/services/application-form-control-manager/application-form-control-manager.service';
import { ReadOnlyWarningModalService } from '../../../modules/application/shared/services/read-only-warning-modal/read-only-warning-modal.service';

@Component({
    selector: 'app-application-layout',
    templateUrl: './application-coordination-layout.component.html',
    styleUrls: ['./application-coordination-layout.component.scss'],
    imports: [
        RouterModule,
        SidenavComponent,
        ApplicationHeaderComponent,
        ApplicationNavigationStepsComponent,
        ApplicationCoordinationNavigationBarComponent,
        ApplicationFooterComponent,
        MasqueradeHeaderComponent,
        AsyncPipe,
        LoadingComponent,
    ],
})
export class ApplicationCoordinationLayoutComponent
    implements OnDestroy, OnInit
{
    private readonly loadingService = inject(LoadingService);
    private readonly applicationStateService = inject(ApplicationStateService);
    private readonly applicationFormControlManager = inject(
        ApplicationFormControlManagerService,
    );
    private readonly readOnlyWarningModalService = inject(
        ReadOnlyWarningModalService,
    );

    destroy$ = new Subject<void>();
    loading$ = this.loadingService.loading$;

    ngOnInit(): void {
        if (this.applicationFormControlManager.isReadOnly()) {
            this.readOnlyWarningModalService.showForReadOnlySubject(
                'application',
            );
        }
    }

    ngOnDestroy(): void {
        this.applicationStateService.clearApplicationState();
        this.destroy$.next();
        this.destroy$.complete();
    }
}
